var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item){return _c('div',{key:item.path},[_c('router-link',{attrs:{"to":item.path}},[_vm._v("\n        "+_vm._s(item.name)+"\n    ")]),_c('p',[_vm._v(_vm._s(item.blurb))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }